module.exports = __webpack_public_path__ + "static/media/blank_block.e24c31e6.PNG";